import { http } from '@/services/http_service';
export default{
    registerPost(_, data)
    {
        //앞단에서 받아서 판별이 필요하기 때문에 return
        return http()
        .post("/post/store", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data);

            return response.data;
        },function(error){
            console.log(error.response.data);
        });
    },
    updatePost(context, data)
    {
        //앞단에서 받아서 판별이 필요하기 때문에 return
        return http()
        .post("/post/update", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data);
            context.commit('setViewPost', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data);
        });
    },
    registerComment(_, data)
    {
        return http()
        .post("/post/comment/store", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data);

            return response.data;
        },function(error){
            console.log(error.response.data);
        });
    },
    fetchLists(context, data)
    {
        return http()
        .post("/post/fetchLists?page="+data.page, data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //console.log("넘겨받은 데이터 확인",data);
            
            context.commit('setPosts', response.data)
            
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    getMyPosts(context, data)
    {
        return http()
        .post("/post/myposts?page="+data.page, data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            console.log("넘겨받은 데이터 확인",data);
            
            context.commit('setPosts', response.data)
            
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    getSearchPosts(context, data)
    {
        return http()
        .post("/post/search?page="+data.page, data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //console.log("넘겨받은 데이터 확인",data);
            
            if(!data.popup){
                context.commit('setPosts', response.data)
            } 
            
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    getPost(context, data)
    {
        return http()
        .post("/post/show",data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log('액션에서',response.data)
            context.commit('setViewPost', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    //인기글 리스트
    getPostRanking()
    {
        return http()
        .post("/post/postRanking")
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log('액션에서',response.data)
            //context.commit('setViewPost', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    updateCount(context, id)
    {
        return http()
        .post("/post/count/"+id)
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log("백단에서 받은 데이터 확인",response.data);           
            context.commit('updateCount', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    updateRecommend(context,data)
    {
        return http()
        .post("/post/recommend/store", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            if( response.data.isRecommend )
            {
                context.commit('updateRecommend', response.data)
                console.log('updateRecommend',response.data);
            }            
            //context.commit('isRecommend', response.data.isRecommend)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    getRecommend(context,data)
    {
        return http()
        .post("/post/recommend/show", data)
        .then((response) => {
            
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    getRecent(context, data)
    {
        return http()
            .post("/post/recent", data)
            .then((response) => {
                //context.commit('setMessages', response.data)
                console.log(response.data)
                console.log("넘겨받은 데이터 확인",data);
                // context.commit('setPosts', response.data)
                return response.data;
            },function(error){
                console.log(error.response.data)
        });    
    },
    reqDelete(context, data)
    {
        //게시글 삭제요청
        return http()
        .post("/post/reqdel/"+data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log("삭제요청 확인",response.data);           
            context.commit('setViewPost', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });     
    },
    Delete(context, data)
    {
        //게시글 삭제- 관리자만 가능
        return http()
        .post("/post/delete/"+data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log("삭제 확인",response.data);           
            context.commit('updatePosts', data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });     
    }
    ,
    deleteComment(context, data)
    {
        //게시글 삭제- 관리자만 가능
        return http()
        .post("/post/comment/delete/"+data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log("삭제 확인",response.data);           
            //context.commit('updatePosts', data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });     
    }


}
